import React, { PureComponent } from 'react'
import { NumberInput, NumberInputField, FormControl, FormErrorMessage } from '@chakra-ui/react'

const HOME_BUTTON_CODE = 36
const END_BUTTON_CODE = 35

export default class FormInput extends PureComponent {
  render() {
    const {
      size,
      fontSize,
      isRequired,
      error,
      ref,
      classNameHolder,
      setRef,
      name,
      prefix,
      prefixCls,
      suffix,
      allowClear,
      id,
      type,
      disabled,
      placeholder,
      className,
      maxLength,
      addonBefore,
      addonAfter,
      onPressEnter,
      onKeyDown,
      onKeyUp,
      onBlur,
      onChange,
      onKeyPress,
      value,
      borderRadius,
      clampValueOnBlur,
      // defaultValue,
    } = this.props

    const fieldProps = {
      size: size ? size : 'large',
      fontSize: fontSize ? fontSize : '16px',
      ref: setRef,
      name,
      prefix,
      prefixCls,
      suffix,
      allowClear,
      id,
      type,
      disabled,
      placeholder,
      className,
      maxLength,
      addonBefore,
      addonAfter,
      onPressEnter,
      onKeyDown,
      onKeyUp,
      onBlur,
      onChange,
      onKeyPress,
      // value,
      // defaultValue,
    }

    return (
      <FormControl
        className={classNameHolder}
        isInvalid={error && error.touched && error.error}
        isRequired={isRequired}
      >
        <NumberInput
          clampValueOnBlur={clampValueOnBlur ?? true}
          variant={error && error.error && error.touched ? 'error' : 'primary'}
        >
          <NumberInputField
            borderRadius={borderRadius}
            value={value}
            ref={ref}
            {...fieldProps}
            onKeyDown={e => {
              const keyCode = e.keyCode ? e.keyCode : e.which
              if (keyCode === END_BUTTON_CODE) {
                e.preventDefault()
                const len = e.target?.value?.length ?? 0
                e.target.setSelectionRange(len, len)
                e.target.focus()
              }
              if (keyCode === HOME_BUTTON_CODE) {
                e.preventDefault()
                e.target.setSelectionRange(0, 0)
                e.target.focus()
              }
              return false
            }}
          />
          <FormErrorMessage>{error && error.error}</FormErrorMessage>
        </NumberInput>
      </FormControl>
    )
  }
}
